import { Hero } from '../sections/Hero';
import { Stats } from '../sections/Stats';
import { Bento } from '../sections/Bento';
import { TwoCol } from '../sections/TwoCol';
import { PullQuote } from '../sections/PullQuote';
import { FinalCTA } from '../sections/FinalCTA';

export function LandingPage() {
  return (
    <>
      <Hero />
      <Stats />
      <Bento />
      <TwoCol />
      <PullQuote />
      <FinalCTA />
    </>
  );
}
